import { Link } from "@remix-run/react";
import { Mail, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import Logo from "./logo";

const Footer = () => {
	const { t } = useTranslation();
	const menus = [
		{ label: "Home", link: "/" },
		{ label: "Project Database", link: "/projects" },
		{ label: "Resources", link: "/resources" },
		{ label: "About", link: "/about" },
	];
	return (
		<footer className="border-t border-t-base-200 mt-12 py-20 px-5 xl:px-0">
			<div className="container mx-auto max-w-7xl">
				<div className="flex flex-col gap-5 sm:flex-row justify-between items-center">
					<Logo size="sm" />
					<div className="flex gap-6">
						{menus.map((item, index) => {
							return (
								<Link to={item?.link} key={index} className="link text-nowrap">
									{item?.label}
								</Link>
							);
						})}
					</div>
				</div>
				<div className="text-center lg:text-left">
					<p className="text-sm my-4">
						Carbon Crediting and REDD+ Secretariat, <br />
						Ministry of Environment <br />
						Lot 503, Morodok Tech Building, <br />
						Phnom Penh, Cambodia
					</p>
					<div className="space-x-2">
						<div className="inline-flex gap-2">
							<Phone className="size-5" />
							<a href="tel:+85523213908" className="text-sm hover:underline">
								+855 23 213 908
							</a>
						</div>
						<div className="inline-flex gap-2">
							<Mail className="size-5" />
							<a
								href="mailto:registry@moe.gov.kh"
								className="text-sm  hover:underline"
							>
								registry@moe.gov.kh
							</a>
						</div>
					</div>
				</div>
				<div className="border-base-200 border-t py-6 mt-10 text-sm">
					<div className="container mx-auto ">
						<div className="flex flex-col-reverse items-center gap-2 md:flex-row md:justify-between w-full opacity-60">
							<div>
								© Copyright {new Date().getFullYear()} Cambodia Carbon Registry
							</div>
							<div className="flex">
								<a href="/privacy" title="Terms and Conditions">
									Privacy Policy
								</a>
								<span className="divider divider-horizontal mx-1"></span>
								<a href="/terms-of-use" title="Terms and Conditions">
									Terms Of Use
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
